import { render } from "./tasks-sidebar.vue?vue&type=template&id=c8dc4a72"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__